var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TabsLayout',[_c('ElTabPane',{attrs:{"name":"designer","label":"3D设计人员"}}),_c('ElTabPane',{attrs:{"name":"designeravgdata","label":"3D设计人均数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }